module.exports = __webpack_public_path__ + "img/hong.8df48b9c.gif";